// import React from "react";

// const MainTitle = () => {
//     return (
//         <div className="sticky top-0 z-20 bg-[#1c2b1e] px-4 py-3 shadow-lg">
//             <div className="text-center">
//                 <p
//                     className="text-[9px] tracking-[0.3em] text-[#a8c5a0] uppercase mb-0.5"
//                     style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
//                 >
//                     Todo lo que tu mascota necesita
//                 </p>
//                 <p
//                     className="text-[24px] font-bold text-[#f5f0e8] leading-tight tracking-tight m-0"
//                     style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
//                 >
//                     Lorena Pets Lover
//                 </p>
//             </div>
//         </div>
//     );
// };

// export default MainTitle;

import React from "react";

const MainTitle = () => {
    return (
        <header className="sticky top-0 z-30 bg-[#0f4a4e] shadow-lg">
            {/* PatrÃ³n sutil de huellas en el fondo */}
            <div
                className="absolute inset-0 opacity-[0.07] pointer-events-none"
                style={{
                    backgroundImage:
                        "radial-gradient(circle at 20% 30%, #fff 2px, transparent 2px), radial-gradient(circle at 80% 70%, #fff 2px, transparent 2px)",
                    backgroundSize: "44px 44px",
                }}
            />

            <div className="relative px-4 py-3 flex items-center justify-center gap-2.5">
                {/* Logo */}
                <img
                    src="/logo_pets.png"
                    alt="Lorena Pets Lover"
                    className="flex-shrink-0 block"
                    style={{
                        width: 46,
                        height: 46,
                        borderRadius: '50%',
                        boxShadow: '0 0 0 3px white, 0 1px 6px rgba(0,0,0,0.3)'
                    }}
                />

                <div className="text-center">
                    <p className="text-[9px] tracking-[0.28em] text-[#f5b98f] uppercase mb-0.5">
                        Comida y artículos para mascotas
                    </p>
                    <h1
                        className="text-[22px] sm:text-[26px] font-extrabold text-[#fdf7ef] leading-none tracking-tight m-0"
                        style={{ fontFamily: "'Poppins', 'Segoe UI', sans-serif" }}
                    >
                        Lorena Pets Lover
                    </h1>
                </div>
            </div>
        </header>
    );
};

export default MainTitle;